import { useMemo } from 'react';
import { ISelectValue } from '../select.types';

export const useFilteredOptions = (
  options: ISelectValue[],
  searchValue: string
) => {
  return useMemo(() => {
    return options.reduce<{
      filteredOptions: ISelectValue[];
      firstAvailableOptionIndex: number;
      lastAvailableOptionIndex: number;
    }>(
      (acc, option) => {
        const matches = option.label
          .toLocaleLowerCase()
          .includes(searchValue.trim().toLocaleLowerCase());

        if (!matches) {
          return acc;
        }

        const index = acc.filteredOptions.length;

        acc.filteredOptions.push(option);

        if (!option.isDisabled) {
          if (acc.firstAvailableOptionIndex === -1) {
            acc.firstAvailableOptionIndex = index;
          }

          acc.lastAvailableOptionIndex = index;
        }

        return acc;
      },
      {
        filteredOptions: [],
        firstAvailableOptionIndex: -1,
        lastAvailableOptionIndex: -1,
      }
    );
  }, [options, searchValue]);
};
